import { TContactInfoBlock } from './index'

export const contactBlockList: (TContactInfoBlock & { title: string })[] = [
	{
		title: `Горячая линия`,
		numberList: [`8 (812) 318-38-38`],
		emailList: [],
		workTime: `Ежедневно с 10:00 до 22:00`
	},
	{
		title: `Сервисный центр`,
		numberList: [`+7 (800) 555-57-61`],
		emailList: [],
		workTime: `Ежедневно с 10:00 до 22:00`
	},
	{
		title: `Для бизнеса`,
		numberList: [`+7 (812) 318-38-36`],
		emailList: [`corp@iport.ru`],
		workTime: `Пн. - Пт. с 10:00 до 18:00`
	}
]
